import WaterForm from "../../components/forms/waterForm";
import WaterTable from "../../components/tables/waterTable";
import LoadingState from "../../components/ui/LoadingState";
import EmptyState from "../../components/ui/EmptyState";
import { useFirestore } from "../../hooks/useFirestore";
import { useChild } from "../../contexts/ChildContext";
import { exportToCSV, waterCSVColumns } from "../../utils/exportUtils";
import { exportSectionPDF } from "../../utils/pdfUtils";

const WaterIntake = (() => {
    const { selectedChild } = useChild();
    const { items: waterIntake, addItem, updateItem, deleteItem, loading, error } = useFirestore("waterIntake", selectedChild?.id);

    const handleAddWater = async (water) => {
        try {
            await addItem({ ...water, childId: selectedChild?.id });
        } catch (err) {
            console.error("Error adding water:", err);
        }
    };

    const handleExport = () => {
        exportToCSV(waterIntake, `water-intake-${selectedChild?.name || "export"}.csv`, waterCSVColumns);
    };

    const handleExportPDF = () => {
        exportSectionPDF(waterIntake, `water-intake-${selectedChild?.name || "export"}.pdf`, waterCSVColumns, "Water Intake", selectedChild?.name || "");
    };

    return (
        <div className="card h-100" id="water-intake">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="card-title mb-0">💧 Water Intake</h5>
                    <div className="d-flex gap-1">
                        <button className="btn btn-sm btn-outline-secondary" onClick={handleExport}>⬇ CSV</button>
                        <button className="btn btn-sm btn-outline-primary" onClick={handleExportPDF}>⬇ PDF</button>
                    </div>
                </div>
                {error && <div className="alert alert-danger">{error}</div>}
                <WaterForm onAdd={handleAddWater} />
                {loading ? (
                    <LoadingState message="Loading water intake..." />
                ) : waterIntake.length > 0 ? (
                    <WaterTable data={waterIntake} onUpdate={updateItem} onDelete={deleteItem} />
                ) : (
                    <EmptyState
            icon="💧"
            heading="No water logged yet"
            message="Start tracking daily water intake to keep hydration on track."
          />
                )}
            </div>
        </div>
    )
});

export default WaterIntake;
